export default __webpack_public_path__ + "static/media/Bottom Navigation.b3f6c073.svg";